import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Header from '@ssg/common/Components/Header';
import UsersOverview from './UsersExternalOverview';
import UsersProxyOverview from './UsersProxyOverview';
import { FeatureFlagEnums } from '@ssg/common/FeatureFlagEnums';
import { useFlag } from '@unleash/proxy-client-react';

const tabs: string[] = ['users.externals', 'users.proxy'];

const UserTabs: React.FC = (): React.ReactElement => {
	const { t } = useTranslation();
	const proxyUserFlag = useFlag(FeatureFlagEnums.PROXY_USER);
	const [activeTab, setActiveTab] = React.useState<string>(tabs[0]);
	const tabsToShow = React.useMemo(() => {
		if (proxyUserFlag) {
			return tabs;
		}
		return tabs.filter(t => t !== 'users.proxy');
	}, [proxyUserFlag]);
	return (
		<div>
			<Header title="users.overviewTitle">
				<div className="flex">
					<div className="flex w-3/4 justify-start">
						{tabsToShow.map((title, i) => {
							return (
								<div className="mr-3 mt-1" key={i}>
									<button
										type="button"
										onClick={() => setActiveTab(title)}
										className={classNames('text-blue focus:outline-none', {
											'border-blue border-b-2': title === activeTab,
										})}
									>
										{t(title)}
									</button>
								</div>
							);
						})}
					</div>
				</div>
			</Header>
			<div>
				{activeTab === 'users.externals' && <UsersOverview />}
				{activeTab === 'users.proxy' && <UsersProxyOverview />}
			</div>
		</div>
	);
};

export default UserTabs;

